import Cookies from 'js-cookie';

export const setCookiesSession = (cookieName, authToken, expiryTime) => {
  // const secondsInMinute = expiryTime / 60;
  // const in120Minutes = secondsInMinute / 1440;
  Cookies.set(cookieName, authToken, {
    expires: expiryTime,
    domain: process.env.REACT_APP_COOKIE_DOMAIN,
  });
};

export const deleteCookie = (cookieName) => {
  // js-cookie's remove() only clears a cookie if the domain/path passed in
  // exactly match how it was set - a mismatch is a silent no-op, not an
  // error. Try every plausible variant so logout reliably clears the
  // session regardless of which one the cookie actually carries.
  const domain = process.env.REACT_APP_COOKIE_DOMAIN;
  Cookies.remove(cookieName, { domain });
  Cookies.remove(cookieName, { domain: `.${domain}` });
  Cookies.remove(cookieName, { path: '/' });
  Cookies.remove(cookieName);
};
export const getCookiesSession = (cookieName) => Cookies.get(cookieName);
